import prescriptionService from '@webServices/prescription.service';
import { element, globalEvent } from '@shared/easyfy.core';
import { invoke } from '@shared/easyfy.decorators';
import { addCss, parseToBoolean, removeCss } from '@shared/easyfy.utils';
import '@webModules/scrollState';

namespace Easyfy.Web.Pages.Prescription {
  @invoke
  class MySubventions {
    static Instance: MySubventions;

    static proxyListElement: HTMLElement;

    static subventionDetailsElement: HTMLElement;

    static loaderString = '<div class="loader m-t-medium" role="status" aria-live="polite" aria-label="Laddar"></div>';

    constructor() {
      MySubventions.Instance = this;
    }

    onInit() {
      globalEvent({
        type: 'click',
        event: {
          action: 'toggle-proxy-list',
          callback: MySubventions.ChangeProxySelectorState
        }
      });

      globalEvent({
        type: 'click',
        event: {
          action: 'change-selected-proxy',
          callback: MySubventions.ChangeSelectedProxy
        }
      });

      MySubventions.proxyListElement = element(
        '[data-container="proxy-list"]'
      ) as HTMLElement;

      if (
        MySubventions.proxyListElement &&
        MySubventions.proxyListElement.attributes['data-loaded']?.value === 'false'
      ) {
        MySubventions.LoadProxyData();
      }
    }

    static LoadProxyData = () => {
      MySubventions.LoadSubventionDetails();
      prescriptionService
        .GetSubventionProxies()
        .then((response) => {
          if (response.status === 200 && response.data.success) {
            if (MySubventions.proxyListElement) {
              MySubventions.proxyListElement.innerHTML =
                response.data.proxyListPartial;
              MySubventions.proxyListElement.setAttribute(
                'data-loaded',
                'true'
              );
            }
          } else {
            MySubventions.proxyListElement.innerHTML = '';
          }
        })
        .catch((error) => {
          console.log(error);
          MySubventions.proxyListElement.innerHTML = '';
        });
    };

    static LoadSubventionDetails = () => {
      MySubventions.subventionDetailsElement = element(
        '[data-container="subvention-details"]'
      ) as HTMLElement;
      const selectedProxyElem = element(
        '[data-container="selected-proxy"]'
      ) as HTMLElement;
      MySubventions.subventionDetailsElement.innerHTML =
        MySubventions.loaderString;
      const proxySsn = selectedProxyElem
        ? selectedProxyElem.attributes['data-selected-id']?.value
        : '';
      const proxyName = selectedProxyElem
        ? selectedProxyElem.attributes['data-name']?.value
        : '';

      let token: string;
      if (selectedProxyElem) {
        token = selectedProxyElem.attributes['data-token']?.value;
      } else {
        const tokenElem = document.querySelector(
          '[data-token]'
        ) as HTMLElement | null;
        if (tokenElem) {
          token = tokenElem.dataset.token;
        }
      }

      const requestData: prescriptionService.SubventionDetailsRequest = {
        selectedUserSsn: proxySsn,
        proxyPersonName: proxyName,
        displayAmountUntilFree: true,
        displayCurrentPeriodCost: true,
        displaySubventionChart: true
      };

      prescriptionService
        .GetSubventionDetails(requestData, token)
        .then((response) => {
          if (
            response.status === 200 &&
            response.data != null &&
            response.data.success
          ) {
            MySubventions.subventionDetailsElement.innerHTML =
              response.data.subventionDetailsPartial;
          } else {
            MySubventions.subventionDetailsElement.innerHTML = '';
          }
        })
        .catch((error) => {
          MySubventions.subventionDetailsElement.innerHTML = '';
          console.log(error);
        });
    };

    static ChangeProxySelectorState = (e) => {
      const state =
        MySubventions.proxyListElement.attributes['data-state']?.value;
      MySubventions.proxyListElement.setAttribute(
        'data-state',
        state === 'open' ? 'closed' : 'open'
      );
      const icon = MySubventions.proxyListElement.querySelector(
        '.right .icon'
      ) as HTMLElement;
      if (icon) {
        if (state === 'open') {
          removeCss(icon, 'icon-caret-up');
          removeCss(icon, 'icon-caret-up');
          addCss(icon, 'icon-caret-down');
        } else {
          removeCss(icon, 'icon-caret-down');
          addCss(icon, 'icon-caret-up');
        }
      }
    };

    static ChangeSelectedProxy = (e) => {
      e.preventDefault();
      e.stopPropagation();
      const proxyElement: HTMLElement = e.target.closest(
        '[data-proxy]'
      ) as HTMLElement;

      const newSsn = proxyElement.attributes['data-proxy-id']?.value;
      const newName = proxyElement.attributes['data-name']?.value;
      const newIsChild = proxyElement.attributes['data-child']?.value;
      const ssnAsText = proxyElement.attributes['data-ssn-text']?.value;

      const selectedProxyElem = element(
        '[data-container="selected-proxy"]'
      ) as HTMLElement;

      selectedProxyElem.setAttribute('data-selected-id', newSsn);
      selectedProxyElem.setAttribute('data-name', newName);
      selectedProxyElem.setAttribute('data-child', newIsChild);
      selectedProxyElem.querySelector('.selected-proxy-display').innerHTML =
        `${newName}, ${ssnAsText}`;

      MySubventions.ChangeProxySelectorState(null);
      MySubventions.LoadSubventionDetails();
    };
  }
}

export default Easyfy.Web.Pages;
